import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './ChooseSubscriberPage.scss';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { setLoginDetails, reportDWH } from '../../EsimUpgradeBlockSlice';
import { proceedAfterSubscriberSelectedAsync } from '../../EsimUpgradeBlockAsyncThunk';

const ChooseSubscriberPage = (props) => {
    const [selectedSubscriber, setSelectedSubscriber] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        props.reportDWH({ actionType: 'eSIM Subscribers Page', status: 'Ongoing', messageText: 'eSIM Subscribers Page Displayed' });
    }, []);

    return (
        <div className='esim-upgrade-choose-subscriber-page-wrapper'>
            <div className='esim-upgrade-choose-subscriber-page'>

                <div className='title'> על איזה מנוי מדובר? </div>

                {
                    props.subscriberList &&
                    <div className='subscriber-list-wrapper'>

                        {
                            props.subscriberList?.map((item, index) => {
                                return (
                                    <a href='#' className={`subscriber-item ${selectedSubscriber == item ? 'selected' : ''}`} onClick={(e) => handleSubscriberClick(e, item)} key={index}>
                                        <span className='subscriber'>{item}</span>
                                    </a>
                                );
                            })
                        }
        
                    </div>
                }

                {error && <div className='error-message'> {error} </div>}

                <div className='button-wrapper'>
                    <BtnSubmit
                        isBusiness={false}
                        text='המשך'
                        onclick={handlePageContinue}
                        formid='esim-block'
                        isDisplayArrows={false}
                        isDisplayWhatsAppIcon={false}
                    />
                </div>

            </div>
        </div>
    );

    function handleSubscriberClick(e, subscriber) {
        e.preventDefault();
        setSelectedSubscriber(subscriber);
        setError('');
    }

    function handlePageContinue() {
        if (!selectedSubscriber) {
            setError('נא לבחור מנוי');
            return;
        }
        props.setLoginDetails({ subscriberNo: selectedSubscriber });
        props.reportDWH({
            actionType: 'eSIM Subscribers Page',
            status: 'Ongoing',
            messageText: 'eSIM Subscribers Page Button Clicked',
            param1: selectedSubscriber,
        });
        props.proceedAfterSubscriberSelectedAsync({ isDisplayLoader: true });
    }

};

const mapStateToProps = (state) => {
    return {
        subscriberList: state.esimUpgradeBlock.subscriberList,
    };
};

const mapDispatchToProps = {
    setLoginDetails,
    proceedAfterSubscriberSelectedAsync,
    reportDWH,
};


export default connect(mapStateToProps, mapDispatchToProps)(ChooseSubscriberPage);
